import { api } from "@/lib/api";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useToast } from "../use-toast";
import { TourAgencyDomain } from "@/models";
import {
  getAllTourAgenciesQueryOptions,
  getTourAgenciesQueryOptions,
  getTourAgencyQueryOptions,
} from "./get.hooks";

const toastDomainMessageMap: Record<TourAgencyDomain, string> = {
  agency: "toast.tourAgencyTourDeleted",
  tour: "toast.tourAgencyAgencyDeleted",
};

const toastDomainErrorMessageMap: Record<TourAgencyDomain, string> = {
  agency: "toast.deleteTourAgencyTourError",
  tour: "toast.deleteTourAgencyAgencyError",
};

export function useDeletetourAgency(
  domain: TourAgencyDomain,
  domainId: string,
  opts?: {
    onSuccess?: () => void;
    onError?: () => void;
  },
) {
  const queryClient = useQueryClient();
  const { toast } = useToast();

  return useMutation({
    mutationFn: (id: string) =>
      api.delete<void>(`/api/tour-agencies/$id`, undefined, {
        pathReplace: { $id: id },
      }),
    onSuccess: (_, id) => {
      queryClient.setQueryData(
        getTourAgenciesQueryOptions(domain, domainId).queryKey,
        (old) => old?.filter((ta) => ta.id !== id),
      );
      queryClient.setQueryData(getAllTourAgenciesQueryOptions.queryKey, (old) =>
        old?.filter((ta) => ta.id !== id),
      );
      queryClient.resetQueries({
        queryKey: getTourAgencyQueryOptions(id).queryKey,
      });
      toast({
        title: toastDomainMessageMap[domain],
        variant: "success",
      });
      opts?.onSuccess?.();
    },
    onError: () => {
      toast({
        title: toastDomainErrorMessageMap[domain],
        variant: "destructive",
      });
      opts?.onError?.();
    },
  });
}
